import { memo, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { X, Building2, Users, Award } from "lucide-react";

const PARTNERS_DATA = [
  {
    name: "Unimed",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641364/unimed_n8t87t.png",
    sector: "Saúde",
    location: "Nacional",
    partnership: "2019",
    description:
      "Maior rede de cooperativas médicas do Brasil, confiando na nossa expertise para recuperação de crédito em saúde.",
  },
  {
    name: "Unip",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641364/unip_emqso5.png",
    sector: "Educação",
    location: "São Paulo",
    partnership: "2020",
    description:
      "Uma das maiores universidades privadas do país, parceira em soluções de cobrança educacional.",
  },
  {
    name: "Stone",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641364/stone_wqxp5n.png",
    sector: "Fintech",
    location: "Rio de Janeiro",
    partnership: "2021",
    description:
      "Líder em soluções de pagamento, confiando na nossa metodologia para recuperação de crédito.",
  },
  {
    name: "Porto Seguro",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641364/porto_seguro_l0kjqv.png",
    sector: "Seguros",
    location: "Nacional",
    partnership: "2018",
    description:
      "Maior seguradora independente do Brasil, parceira em recuperação de crédito de seguros.",
  },
  {
    name: "Picpay",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641362/picpay_gp9mvz.png",
    sector: "Fintech",
    location: "São Paulo",
    partnership: "2022",
    description:
      "Carteira digital líder no Brasil, confiando na nossa expertise em cobrança digital.",
  },
  {
    name: "Multiplix",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641361/multiplix_muprs6.png",
    sector: "Tecnologia",
    location: "São Paulo",
    partnership: "2021",
    description:
      "Empresa de tecnologia financeira, parceira em soluções inovadoras de recuperação.",
  },
  {
    name: "Movida",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641361/movida_vsouqu.png",
    sector: "Locação",
    location: "Nacional",
    partnership: "2020",
    description:
      "Líder em locação de veículos, confiando na nossa metodologia para cobrança automotiva.",
  },
  {
    name: "Jive",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641361/jive_ly3i7f.png",
    sector: "Tecnologia",
    location: "São Paulo",
    partnership: "2022",
    description:
      "Empresa de soluções tecnológicas, parceira em recuperação de crédito B2B.",
  },
  {
    name: "Imc",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641361/imc_dn4xyj.png",
    sector: "Consultoria",
    location: "Rio de Janeiro",
    partnership: "2019",
    description:
      "Consultoria empresarial de referência, confiando na nossa expertise em cobrança corporativa.",
  },
  {
    name: "Habibs",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641361/habibs_rbsidi.png",
    sector: "Alimentação",
    location: "Nacional",
    partnership: "2021",
    description:
      "Maior rede de fast food árabe do Brasil, parceira em recuperação de crédito do varejo.",
  },
  {
    name: "Firma Capital",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641360/firma_capital_iiiogi.png",
    sector: "Investimentos",
    location: "São Paulo",
    partnership: "2020",
    description:
      "Gestora de investimentos, confiando na nossa metodologia para recuperação financeira.",
  },
  {
    name: "Cashme",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641360/cashme_ol9vgs.png",
    sector: "Fintech",
    location: "São Paulo",
    partnership: "2022",
    description:
      "Plataforma de antecipação de recebíveis, parceira em soluções de cobrança inovadoras.",
  },
  {
    name: "Camil",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641360/camil_xwjwdj.png",
    sector: "Alimentos",
    location: "Nacional",
    partnership: "2019",
    description:
      "Líder em produtos alimentícios, confiando na nossa expertise para cobrança no agronegócio.",
  },
  {
    name: "BBC Digital",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641360/bbc-digital_jmwx5g.png",
    sector: "Marketing",
    location: "São Paulo",
    partnership: "2021",
    description:
      "Agência de marketing digital, parceira em recuperação de crédito para agências.",
  },
  {
    name: "Banco Original",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641360/banco_original_crn8kj.png",
    sector: "Financeiro",
    location: "Nacional",
    partnership: "2018",
    description:
      "Banco digital inovador, confiando na nossa metodologia para recuperação bancária.",
  },
  {
    name: "Farias Brito",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641360/farias_brito_osam3l.png",
    sector: "Educacional",
    location: "Nacional",
    partnership: "2016",
    description:
      "Colégio nacional de referência, parceiro em soluções de cobrança educacional.",
  },
  {
    name: "Consórcio Crasa",
    logo: "https://res.cloudinary.com/dy5qtniog/image/upload/f_auto,q_auto/v1774641360/consorcio_crasa_oiftfp.png",
    sector: "Consórcios",
    location: "Nacional",
    partnership: "2024",
    description: "Consórcio Crasa, referência nacional em consórcios.",
  },
] as const;

import { useEffect, useRef } from "react";

const PartnersLogos = memo(() => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const sectionRef = useRef<HTMLElement | null>(null);

  // Pause carousel when off-screen
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      ([entry]) => setIsPaused(!entry.isIntersecting),
      { threshold: 0 },
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  // Bloqueia o scroll do body enquanto o modal estiver aberto
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = originalOverflow || "";
    }
    return () => {
      document.body.style.overflow = originalOverflow || "";
    };
  }, [isModalOpen]);
  // Dividir os parceiros em duas fileiras
  const firstRow = useMemo(() => PARTNERS_DATA.slice(0, 8), []);
  const secondRow = useMemo(() => PARTNERS_DATA.slice(8), []);

  // Duplicar para loop infinito
  const firstRowLogos = useMemo(() => [...firstRow, ...firstRow], [firstRow]);
  const secondRowLogos = useMemo(
    () => [...secondRow, ...secondRow],
    [secondRow],
  );

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.1 },
    },
  };
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
  };
  const scaleVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
  };

  return (
    <>
      <motion.section
        id="parceiros"
        className="partners-section"
        ref={sectionRef}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
        viewport={{ once: true, margin: "50px" }}
      >
        <div className="partners-container">
          {/* Título da seção */}
          <motion.div
            className="text-center mb-16"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "50px" }}
          >
            <motion.div
              className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-red-50 via-gray-50 to-red-50 rounded-full mb-6"
              variants={scaleVariants}
            >
              <div className="w-2 h-2 bg-red-500 rounded-full mr-2 w-2 h-2 bg-red-500 rounded-full"></div>
              <span className="text-sm font-semibold bg-gradient-to-r from-red-600 via-gray-600 to-red-600 bg-clip-text text-transparent">
                Parceiros de Confiança
              </span>
            </motion.div>

            <motion.h2
              className="text-3xl lg:text-4xl font-bold mb-4"
              variants={itemVariants}
            >
              <span className="bg-gradient-to-r from-gray-900 via-red-800 to-gray-800 bg-clip-text text-transparent">
                Empresas que confiam em Nosso trabalho
              </span>
            </motion.h2>

            <motion.p
              className="text-lg text-gray-600 max-w-2xl mx-auto"
              variants={itemVariants}
            >
              Grandes marcas já confiam na nossa expertise em recuperação de
              crédito.
            </motion.p>
          </motion.div>

          {/* Carrossel duplo */}
          <div className="relative mb-16">
            {/* Primeira fileira - desliza para esquerda */}
            <div className="carousel-row overflow-hidden">
              <div
                className={`carousel-track carousel-left${isPaused ? " paused" : ""}`}
              >
                {firstRowLogos.map((partner, index) => (
                  <div
                    key={`first-${partner.name}-${index}`}
                    className="logo-item"
                  >
                    <img
                      src={partner.logo}
                      alt={`Logo ${partner.name}`}
                      width={240}
                      height={120}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Segunda fileira - desliza para direita */}
            <div className="carousel-row overflow-hidden">
              <div
                className={`carousel-track carousel-right${isPaused ? " paused" : ""}`}
              >
                {secondRowLogos.map((partner, index) => (
                  <div
                    key={`second-${partner.name}-${index}`}
                    className="logo-item"
                  >
                    <img
                      src={partner.logo}
                      alt={`Logo ${partner.name}`}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Gradientes laterais */}
            <div className="fade-edges fade-left" />
            <div className="fade-edges fade-right" />
          </div>

          {/* Texto final */}
          <div className="text-center mt-12">
            <p className="text-md text-gray-700 max-w-3xl mx-auto leading-relaxed">
              <button
                onClick={() => setIsModalOpen(true)}
                className="font-semibold text-red-600 hover:text-red-700 underline decoration-red-600 underline-offset-4 hover:underline-offset-2 transition-all duration-200 mr-2"
                aria-label="Ver detalhes dos parceiros"
              >
                Empresas líderes
              </button>
              confiam na nossa experiência. Junte-se a marcas de referência que
              escolheram nossa expertise em recuperação de crédito.
            </p>
          </div>
        </div>
      </motion.section>

      {/* Modal de Parceiros Detalhado */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-white rounded-2xl max-w-7xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
          >
            <div className="sticky top-0 bg-white border-b border-gray-100 px-8 py-6 flex items-center justify-between rounded-t-2xl">
              <div>
                <h3 className="text-2xl font-bold text-gray-900">
                  Nossos Parceiros
                </h3>
                <p className="text-gray-600 mt-1">
                  Empresas que confiam na nossa expertise em recuperação de
                  crédito
                </p>
              </div>
              <button
                onClick={() => setIsModalOpen(false)}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                aria-label="Fechar detalhes dos parceiros"
              >
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>

            <div className="p-8">
              <div className="mb-8">
                <div className="flex items-center mb-6">
                  <Building2 className="w-6 h-6 text-red-600 mr-3" />
                  <h4 className="text-xl font-semibold text-gray-900">
                    Portfolio de Clientes
                  </h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {PARTNERS_DATA.map((partner, index) => (
                    <div
                      key={index}
                      className="bg-white p-6 rounded-xl border border-gray-200 hover:shadow-lg hover:border-gray-300 transition-all duration-300"
                    >
                      <div className="flex items-start justify-between mb-4">
                        <div className="w-16 h-16 bg-gray-50 rounded-lg flex items-center justify-center border border-gray-200 overflow-hidden">
                          <img
                            src={partner.logo}
                            alt={`Logo ${partner.name}`}
                            className="w-12 h-12 object-contain"
                          />
                        </div>
                        <div className="text-right">
                          <span className="text-xs font-medium text-red-700 bg-red-100 px-2 py-1 rounded-full">
                            {partner.sector}
                          </span>
                        </div>
                      </div>

                      <h5 className="text-lg font-bold text-gray-900 mb-2">
                        {partner.name}
                      </h5>
                      <p className="text-sm text-gray-600 line-clamp-3">
                        {partner.description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </>
  );
});

PartnersLogos.displayName = "PartnersLogos";
export default PartnersLogos;
